// AlzheimersDementiaCare.js
import React from 'react';
import ServiceHero from '../components/ServiceHero';
import CompassionateApproachSection from '../components/CompassionateApproachSection';
import HighlyTrainedCaregiversSection from '../components/HighlyTrainedCaregiversSection';
import ThreeStepsSection from '../components/ThreeStepsSection';
import SafeEnvironmentSection from '../components/SafeEnvironmentSection';
import AllServicesShowcase from '../components/AllServicesShowcase';

const AlzheimersDementiaCare = () => {
  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Home Care Services', link: '/services' },
    { label: "Alzheimer's and Dementia Care", link: null }
  ];

  return (
    <div className="min-h-screen bg-white">
      <ServiceHero
        breadcrumbs={breadcrumbs}
        title="Home Care For Seniors With Alzheimer's and Dementia"
        description="Our dementia carers take into account each client's environment and special needs, thereby making daily life less difficult and stressful."
      />
      <CompassionateApproachSection />
      <HighlyTrainedCaregiversSection />
      <ThreeStepsSection />
      <SafeEnvironmentSection />
      <AllServicesShowcase />
    </div>
  );
};

export default AlzheimersDementiaCare;
